import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const pageApi = (params) => {
  return request({
    url: env.ferryUrl + '/work-order/page',
    method: 'POST',
    data: params
  })
}
// 工单详情
export const workInfo = (id) => {
  return request({
    url: env.ferryUrl + `/work-order/info/${id}`,
    method: 'get'
  })
}
// 创建工单
export const workOrderSave = (params) => {
  return request({
    url: env.ferryUrl + '/work-order/save',
    method: 'post',
    data: params
  })
}
// 车辆-司机审核特殊处理
export const specialSave = (params) => {
  return request({
    url: env.ferryUrl + '/work-order/special-save',
    method: 'post',
    data: params
  })
}
// 处理工单
export const handleWork = (params) => {
  return request({
    url: env.ferryUrl + '/work-order/handle-work-order',
    method: 'post',
    data: params
  })
}

// 禁用
export const workTypeDisable = (params) => {
  return request({
    url: env.ferryUrl + '/work-order-type/disable',
    method: 'post',
    data: params
  })
}
// 保存工单类型
export const configSave = (params) => {
  return request({
    url: env.ferryUrl + '/work-order-type/save-update',
    method: 'post',
    data: params
  })
}
// 获取工单类型树
export const getWorkTypeTree = () => {
  return request({
    url: env.ferryUrl + '/work-order-type/tree',
    method: 'GET'
  })
}
// 获取工单类型详情
export const workTypeInfo = (id) => {
  return request({
    url: env.ferryUrl + `/work-order-type/info/${id}`,
    method: 'GET'
  })
}
/**
 * 通过供应商获取用户
 */
export const getSysUserByMerchantId = (params) => {
  return request({
    url: env.ferryUrl + `/user/getSysUserByMerchantId/${params}`,
    method: 'GET'
  })
}
/**
 * 通过供应商获取用户
 */
export const changeUser = (params) => {
  return request({
    url: env.ferryUrl + '/work-order/change-user',
    method: 'post',
    data: params
  })
}

/**
 * 根据工单类型获取常用语
 */
export const commonExpressions = (typeId) => {
  return request({
    url: env.ferryUrl + `/work-order-type/commonExpressions/list/${typeId}`,
    method: 'GET'
  })
}
/**
 * 常用语删除
 */
export const deleteCommon = (id) => {
  return request({
    url: env.ferryUrl + `/work-order-type/commonExpressions/remove/${id}`,
    method: 'GET'
  })
}
/**
 * 常用语保存或更新
 */
export const saveCommon = (params) => {
  return request({
    url: env.ferryUrl + '/work-order-type/commonExpressions/save-update',
    method: 'post',
    data: params
  })
}
